import React, { useState, useEffect } from "react";
import ProductPreview from "./utility/product-preview";
import HeaderBackground from "../images/vigneto.png";

function CollectionsMockup() {
  const myCollections = [
    {
      id: 1000000001,
      imageUrl: "https://picsum.photos/id/71/325/325",
      imageAlt: "Bottiglia di vino rosso pregiato",
      numberOf: "001",
      type: "Riserva",
      title: "Brunello di Montalcino DOCG",
      description:
        "Un vino rosso intenso e strutturato, con sentori di ciliegia matura, tabacco e spezie. Perfetto per piatti di carne e formaggi stagionati.",
      ctaText: "vedi il prodotto",
      ctaLink: "/",
    },
    {
      id: 1000000002,
      imageUrl: "https://picsum.photos/id/72/325/325",
      imageAlt: "Calice di vino bianco fresco",
      numberOf: "046",
      type: "Classico",
      title: "Vermentino di Gallura DOCG",
      description:
        "Un bianco fresco e fruttato con note agrumate e floreali, ideale per accompagnare piatti di pesce e antipasti leggeri.",
      ctaText: "vedi il prodotto",
      ctaLink: "/",
    },
    {
      id: 1000000003,
      imageUrl: "https://picsum.photos/id/73/325/325",
      imageAlt: "Bottiglia di vino rosato elegante",
      numberOf: "127",
      type: "Selezione",
      title: "Cerasuolo d'Abruzzo DOC",
      description:
        "Un rosato vivace con aromi di fragola e melograno, dal gusto equilibrato e armonioso. Perfetto con salumi e primi piatti mediterranei.",
      ctaText: "vedi il prodotto",
      ctaLink: "/",
    },
    {
      id: 1000000004,
      imageUrl: "https://picsum.photos/id/74/325/325",
      imageAlt: "Bottiglia di vino spumante",
      numberOf: "298",
      type: "Spumante",
      title: "Franciacorta Brut DOCG",
      description:
        "Uno spumante elegante con bollicine fini e persistenti, dal bouquet di fiori bianchi e crosta di pane. Perfetto per brindisi e aperitivi.",
      ctaText: "vedi il prodotto",
      ctaLink: "/",
    },
    {
      id: 1000000005,
      imageUrl: "https://picsum.photos/id/75/325/325",
      imageAlt: "Bottiglia di vino passito dolce",
      numberOf: "500",
      type: "Dolce",
      title: "Passito di Pantelleria DOC",
      description:
        "Un vino dolce e avvolgente con intense note di albicocca, miele e fichi secchi. Il suo bouquet aromatico conquista il palato, perfetto con formaggi erborinati, dessert cremosi e frutta secca.",
      ctaText: "vedi il prodotto",
      ctaLink: "/",
    },
  ];
  return (
    <div className="collections-page">
      <div
        className="container-cust-fluid header"
        style={{ backgroundImage: `url(${HeaderBackground})` }}
      >
        <div className="container-cust">
          <img
            className="custom-logo"
            src="https://picsum.photos/id/412/180/180"
            alt=""
          />
        </div>
      </div>
      <div className="container-cust content mx-auto">
        <div className="title-container">
          <div>
            <h1>Terre del Sud</h1>
            <span>5 Collezioni</span>
          </div>
          <div className="select-container">
            <select className="custom-select" name="order" id="select-order">
              <option value="">Ordina</option>
              <option value="recenti">Recenti</option>
              <option value="importanti">Importanti</option>
            </select>
            <svg className="arrow-icon" viewBox="0 0 24 24">
              <path d="M7 10l5 5 5-5z" />
            </svg>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-x-4 gap-y-6">
          {myCollections.map((collection) => (
            <div className="col-span-12 sm:col-span-6 lg:col-span-4">
              <ProductPreview
                key={collection.id}
                prod={collection}
                showDescription={false}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CollectionsMockup;
